export class PermissaoUsuario {
   codigo: string;
   descricao: string;
   id: string;
   nome: string;
   idValorConsulta: number;

   checked = false;
   disabled = false;

   constructor(p) {
    this.codigo = p['codigo'] || null;
    this.descricao = p['descricao'] || null;
    this.id = p['id'] || null;
    this.nome = p['nome'] || null;
    this.idValorConsulta = p['idValorConsulta'] || null;
    this.checked = p['checked'] || false;
  }
}
